import { FormType } from '../../../models/notices/ojeu.notice.enums';

export abstract class HvtSectionBase<T> {
    protected formType: FormType;
    
    abstract populate(hvtSection: T, formType: FormType);
    abstract clear();

    splitMultiLine(obj: string) {
        if (obj) {
            return obj.split('<br/>');
        }
        return [];
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.base.ts